export const API = {
  CONTENT: {
    DOMAIN: process.env.NEXT_PUBLIC_API_CONTENT_DOMAIN || 'localhost',
    PORT: process.env.NEXT_PUBLIC_API_CONTENT_PORT || '3040',
    HOST: process.env.NEXT_PUBLIC_API_CONTENT_HOST || 'http://localhost:3040',
    TOKEN: process.env.NEXT_PUBLIC_API_CONTENT_TOKEN || 'sdsf',
  },
  PENPOT: {
    HOST: process.env.NEXT_PUBLIC_API_PENPOT_HOST || 'http://localhost:9001',
    TEAM_ID: process.env.NEXT_PUBLIC_PENPOT_TEAM_ID || '',
  },
}

export const GRIST = {
  DOMAIN: process.env.NEXT_PUBLIC_GRIST_DOMAIN || 'localhost',
  PORT: process.env.NEXT_PUBLIC_GRIST_PORT || '8484',
  HOST: process.env.NEXT_PUBLIC_GRIST_HOST || 'http://localhost:8484',
  DEFAULT: {
    PROJECT_DOMAIN: process.env.NEXT_PUBLIC_GRIST_DEFAULT_PROJECT_DOMAIN || 'energy-dev',
    EVENTS_WORKSPACE: process.env.NEXT_PUBLIC_GRIST_DEFAULT_EVENTS_WORKSPACE || 'events_workspace',
  }
}

export const N8N = {
  DOMAIN: process.env.NEXT_PUBLIC_N8N_DOMAIN || 'localhost',
  PORT: process.env.NEXT_PUBLIC_N8N_PORT || '3000',
  HOST: process.env.NEXT_PUBLIC_N8N_HOST || 'http://localhost:3000',
  TOKEN: process.env.NEXT_PUBLIC_N8N_TOKEN || 'sdsf',
}

